/** Total inactivity duration before kiosk auto-resets (ms). */
export const KIOSK_INACTIVITY_TIMEOUT_MS = 90_000

/** Delay before the inactivity warning modal appears (ms). */
export const KIOSK_INACTIVITY_WARNING_MS = 60_000

/** Starting value for the countdown displayed in the warning modal (seconds). */
export const KIOSK_INACTIVITY_COUNTDOWN_SEC = 30

/** Auto-reset delay after a walk-in queue booking (ms). */
export const KIOSK_AUTO_RESET_WALK_IN_MS = 5_000

/** Auto-reset delay after a scheduled (future) appointment booking (ms). */
export const KIOSK_AUTO_RESET_SCHEDULED_MS = 20_000
